$(document).ready(function(){
  $('.ProductForm__RequestItem').on('click', function(e) {
    $(this).toggleClass("pressed");
    $('.ProductForm__RequestItemForm').slideToggle(300);
    e.preventDefault();
  });

  $('.ProductForm__OrderItem').on('click', function(e) {
    $(this).toggleClass("pressed");
    $('.ProductForm__OrderItemForm').slideToggle(300);
    e.preventDefault();
  });
});

document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  $('#selectedVariant').val(variant.name);
});

$(document).ready(function(){
  setTimeout(function() {
	$('.CartItem__Property').each(function() {
          var text = $(this).text();
          $(this).text(text.replace('giftcard_sender_name', 'GIFTED BY').replace('giftcard_sender_email', 'SENDER EMAIL').replace('giftcard_recipient_name', 'GIFTED TO').replace('giftcard_recipient_email', 'RECIPIENT EMAIL').replace('giftcard_message', 'MESSAGE')); 
	});
  }, 1000);
  
  $('.collection--in-store-request').on('click', function(e) {
    $(this).toggleClass("pressed");
    $('.collection--in-store-request-form').slideToggle(300);
    e.preventDefault();
  });
});

document.addEventListener('cart:change', function(event) {
   setTimeout(function() {
	$('.CartItem__Property').each(function() {
          var text = $(this).text();
          $(this).text(text.replace('giftcard_sender_name', 'GIFTED BY').replace('giftcard_sender_email', 'SENDER EMAIL').replace('giftcard_recipient_name', 'GIFTED TO').replace('giftcard_recipient_email', 'RECIPIENT EMAIL').replace('giftcard_message', 'MESSAGE')); 
	});
  }, 100);
});

$(window).scroll(function() {
  var y = $(this).scrollTop();
  if (y > 200) {
    $('.back-to-top').fadeIn();
  } else {
    $('.back-to-top').fadeOut();
  }
});

document.addEventListener("DOMContentLoaded", function(event) {
  var hash = window.location.hash;
  console.log(hash);
  if(hash == "#contact_form") {
    console.log('true');
    $('.ProductForm__OrderItemForm').show();
    setTimeout(function() {
      const t = document.querySelector("#contact_form");
      t.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }, 2000);
  }
});